module.exports = __webpack_public_path__ + "img/articleMangerMieux.8b71b0cc.png";